<app-main-layout>
  <app-event-view-page></app-event-view-page>
</app-main-layout>
